import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-progress-bar',
  styleUrl: 'lab-ds-progress-bar.css',
  shadow: true,
})
export class LabDsProgressBar {
  @Prop() progress: number;

  render() {
    return (
      <div class={`v4-progress-bar`}>
        <div style={{ width: `${this.progress}%` }} class="progress-bar-completed"></div>
      </div>
    );
  }
}
